<ng-container [ngSwitch]="viewType">
  <ng-container *ngSwitchCase="'CardView'">
    <ptl-card-item-main-view class="card-item-main" [card]="card" (cardClick)="cardClick.emit(this.card)"></ptl-card-item-main-view>
  </ng-container>

  <ng-container *ngSwitchCase="'ListView'">
    <ptl-card-item-list-view [card]="card" (cardClick)="cardClick.emit(this.card)"></ptl-card-item-list-view>
  </ng-container>

  <ng-container *ngSwitchCase="'SnakeView'">
    <ptl-card-item-snake-view [card]="card" (cardClick)="cardClick.emit(this.card)"></ptl-card-item-snake-view>
  </ng-container>
</ng-container>
